import { useQuery } from "@tanstack/react-query";
import { api } from "api";
import { queryKeys } from ".";
import useAuth from "features/auth/useAuth";
import Claims from "features/auth/claims";

const refetchInterval =
  process.env.REACT_APP_FAILURE_DEADLINE_COUNT_INFO_REFETCH_INTERVAL &&
  process.env.REACT_APP_FAILURE_DEADLINE_COUNT_INFO_REFETCH_INTERVAL !== ""
    ? process.env.REACT_APP_FAILURE_DEADLINE_COUNT_INFO_REFETCH_INTERVAL
    : undefined;

const useFailureDeadlineInfoQuery = () => {
  const { hasClaim } = useAuth();

  const query = useQuery(
    queryKeys.failures.deadlineInfoCount,
    () =>
      api.lumen.failures.apiFailuresGetCountPost({ getFailureCountQuery: {} }),
    {
      refetchInterval: refetchInterval ? parseInt(refetchInterval, 10) || 0 : 0,
      enabled: hasClaim([Claims.Failure.Read, Claims.Failure.ReadOwn]),
    }
  );

  return query;
};

export default useFailureDeadlineInfoQuery;
